import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Button, Card, Image } from "react-bootstrap";
import logo from "../assets/ts_ads_logo.svg";
import aboutTS from "../assets/img1.gif";
import TSlogo from "../assets/ts_logo_w.png";
import axios from "axios";
import ButtonLoader from "../components/ButtonLoader";
import { Helmet } from "react-helmet";
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

const Login = () => {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const isLogin = localStorage.getItem("isLogin") || "0";
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState("");

  const location = useLocation();

  useEffect(() => {
    const checkLoginAndFetchToken = async () => {
      if (isLogin === "1" && accounts && accounts.length > 0) {
        setLoading(true);
        const accessToken = await getAccessToken(accounts[0]);
        if (accessToken) {
          axios
            .post(
              process.env.REACT_APP_BASE_URL + "/api/auth/microsoft/token",
              {
                code: accessToken,
              }
            )
            .then((response) => {
              processLoginResponse(response);
            })
            .catch((error) => console.error("Token Exchange Error:", error));
        }
      }
    };

    checkLoginAndFetchToken();
  }, [accounts, isLogin]);

  const getAccessToken = async (account) => {
    try {
      const response = await instance.acquireTokenSilent({
        scopes: ["openid", "profile", "email"],
        account: account,
      });
      return response.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        // User interaction is required (e.g., token expired)
        return instance
          .acquireTokenPopup({
            scopes: ["openid", "profile", "email"],
          })
          .then((response) => response.accessToken);
      }
      console.error("Token acquisition failed:", error);
      return null;
    }
  };

  const processLoginResponse = (response) => {
    setLoading(false);
    if (response.status === 200) {
      const success = response.data.success;
      if (success === 1) {
        const userData = response.data.data;
        const token = response.data.token;
        localStorage.setItem("userData", JSON.stringify(userData));
        localStorage.setItem("token", token);
        let roleDefault = "/library";
        if (userData.default_path) {
          roleDefault = userData.default_path;
        }
        const redirectPath = location.state?.from?.pathname || roleDefault;
        navigate(redirectPath, { replace: true });
      } else {
        setLoginErrorMessage(response.data.data);
        setLoginError(true); // Email is not registered
        navigate("/");
        setTimeout(() => {
          setLoginErrorMessage("");
          setLoginError(false);
        }, 10000);
      }
    }
  };

  const loginHandler = async () => {
    try {
      setLoading(true);
      localStorage.setItem("isLogin", "1");
      const loginResponse = await instance.loginRedirect({
        scopes: ["openid", "profile", "email"],
      });
      console.log("Login Success", loginResponse);
    } catch (error) {
      console.error("Login Error", error);
    }
  };

  return (
    <Container fluid className="login-page bg-light p-0">
      <Helmet>
        <title>{`${process.env.REACT_APP_NAME} | Login`}</title>
      </Helmet>
      <div className="container2">
        <div className="bg-white ful_ht">
          <div className="row">
            {/* Left Column */}
            <div className="col-md-4 pe-0 h-mble">
              <div className="login-left">
                <Image src={logo} alt="Digital Signage" />
                <div className="col-12 py-5">
                  <h1>Digital Signage Software for Enterprises</h1>

                  <Button
                    variant="primary"
                    type="button"
                    className="btn btn-primary px-4 mt-4 lgn_btn"
                    onClick={loginHandler}
                  >
                    {!loading ? `SSO Login` : <ButtonLoader />}
                  </Button>
                  {loginError === true && (
                    <div className="alert alert-danger my-3" role="alert">
                      {loginErrorMessage}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-md-8 ps-0 d-md-block">
              <div className="form-right text-white text-center pt-5 bg_img">
                <Image src={TSlogo} alt="TS Logo White" className="logo-ts" />
                <h2 className="h-mble">
                  The best cloud-based digital signage software to manage your
                  screens anytime and anywhere
                </h2>
                <Image src={aboutTS} alt="About TS" className="abt-ts h-mble" />

                {/* Hidden on mobile */}
                <div className="login-left h-desk">
                  <Image src={logo} alt="Digital Signage" />
                  <div className="col-12 py-5">
                    <h1>Digital Signage Software for Enterprises</h1>
                    <p>
                      The best cloud-based digital signage software to manage
                      your screens anytime and anywhere
                    </p>
                    <Button
                      variant="primary"
                      type="button"
                      className="btn btn-primary px-4 mt-4 lgn_btn"
                      onClick={loginHandler}
                    >
                      {!loading ? `SSO Login` : <ButtonLoader />}
                    </Button>
                    {loginError === true && (
                      <div className="alert alert-danger my-3" role="alert">
                        {loginErrorMessage}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Login;
